export const mockJobSeekerProfile = {
  id: 1,
  user_id: 12,
  user_name: "",
  nationality: {
    id: 19,
    name: "Syrian",
    name_trans: { ar: "سوري" },
  },
  title_id: 1,
  title_name: "",
  title_name_trans: { ar: "" },
  country_id: 19,
  country_name: "Syria",
  country_name_trans: { ar: "سوريا" },
  city_id: 20,
  city_name: "Damascus",
  city_name_trans: { ar: "دمشق" },
  full_name: "",
  full_name_arabic: { ar: "" },
  birthdate: "",
  gender: "MALE",
  marital_status: "single",
  military_service: "FINISHED",
  military_service_date: "",
  confidetial: false,
  driving_license: "TYPE_A",
  driving_license_date: "",
  image: null,
  address_english: "",
  address_arabic: [""],
  phone_number: "",
  created_at: "",
  updated_at: "",
};

export const genderOptions = [
  { value: "MALE", label: "Male", arabic_label: "ذكر" },
  { value: "FEMALE", label: "Female", arabic_label: "أنثى" },
];

export const militaryServiceOptions = [
  { value: "FINISHED", label: "Finished", arabic_label: "منتهية" },
  { value: "NOT_FINISHED", label: "Not Finished", arabic_label: "غير منتهية" },
  { value: "EXEMPTED", label: "Exempted", arabic_label: "معفى" },
];

export const maritalStatusOptions = [
  { value: "single", label: "Single", arabic_label: "أعزب" },
  { value: "married", label: "Married", arabic_label: "متزوج" },
];

export const drivingLicenseOptions = [
  { value: "TYPE_A", label: "Type A", arabic_label: "النوع أ" },
  { value: "TYPE_B", label: "Type B", arabic_label: "النوع ب" },
  { value: "TYPE_C", label: "Type C", arabic_label: "النوع ج" },
  { value: "TYPE_D", label: "Type D", arabic_label: "النوع د" },
  { value: "TYPE_E", label: "Type E", arabic_label: "النوع هـ" },
  { value: "NONE", label: "None", arabic_label: "بدون" },
];
